import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import IMAGES from 'constants/Images';
import {isInAppWebview, sendEventsToNativeApp} from 'utils/ClientAppUtils';
import { triggerToast } from '../../../helpers';
import env from 'env';


const propTypes = {
  onAddFunds: PropTypes.func.isRequired,
};

const AddFundCard = ({kycData}) => {

  const handleAddFunds = () => {
    if (!kycData?.flow || !kycData?.status || !kycData?.crn) {
      triggerToast.error('Missing required kycData fields');
      return;
    }
  
    const baseUrl = env.ADD_FUNDS_URL;
    const url = new URL(baseUrl);
  
    url.searchParams.set('context', 'pre_kyc_verification');
    url.searchParams.set('flow', kycData.flow);
    url.searchParams.set('status', kycData.status);
    url.searchParams.set('crn', kycData.crn);
  
    const deepLink = url.toString();
  
    if (isInAppWebview()) {
      try {
        sendEventsToNativeApp(JSON.stringify({
          type: 'ADD_FUNDS',
          deepLink,
          context: 'pre_kyc_verification',
        }));
      } catch (err) {
        triggerToast.error('Native bridge failed, falling back to web redirect');
      }
      return;
    }
  
    window.open(deepLink, '_blank', 'noopener,noreferrer');
  };

  return (
    <AddFundsCardWrapper>
      <TradingCard>
        <CardContent>
          <CardLeft>
            <CardTitle className="body-medium">Complete your Trading setup</CardTitle>
            <CardDescription className="body-small">
              Verification is in progress. Set up your balance now to start trading instantly upon
              approval.
            </CardDescription>
            <AddFundsButton onClick={handleAddFunds} className="body-small">
              Add Funds
              <img
                src={IMAGES.arrowRightBlack}
                alt="Arrow"
                style={{width: 12, height: 12, marginLeft: 4}}
              />
            </AddFundsButton>
          </CardLeft>
          <CardImageContainer>
            <img src={IMAGES.add_fund} alt="Add Funds" style={{width: 108, height: 150, objectFit: 'cover' }} />
          </CardImageContainer>
        </CardContent>
      </TradingCard>
    </AddFundsCardWrapper>
  );
};


const AddFundsCardWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const TradingCard = styled.div`
  width: 80%;
  background: linear-gradient(135deg, #f3eeff 0%, #ede8fb 100%);
  border-radius: 16px;
  padding: 1.5rem;
  text-align: left;
  @media (max-width: 1024px) {
    width: 90%;
  }
`;

const CardContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  `;

const CardLeft = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  flex: 1;
`;

const CardTitle = styled.h2`
  margin: 0;
  padding: 0;
  color: #000000;
  font-weight: 700 !important;
`;

const CardDescription = styled.p`
  margin: 0;
  padding: 0;
  color: #4b5563;
  line-height: 1.5;
`;

const AddFundsButton = styled.button`
  display: inline-flex;
  align-items: center;
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  color: #000000;
  font-weight: 500;
  margin-top: 0.5rem;

  &:hover {
    color: #6725f4;

    img {
      filter: invert(20%) sepia(90%) saturate(3000%) hue-rotate(250deg) brightness(80%);
    }
  }
`;

const CardImageContainer = styled.div`
  flex-shrink: 0;
`;

AddFundCard.propTypes = propTypes;

export default AddFundCard;
